import type { MetaDescriptor } from '@remix-run/node';

export const createWebsiteSchema = (host: string): MetaDescriptor[] => {
    return [
        {
            '@context': 'http://schema.org',
            '@type': 'WebSite',
            // Use the single brand name across every market so Google treats the
            // NZ/AU/US sites as one entity (the per-market site is disambiguated
            // by `url`/host, not by appending the country code to the name).
            name: 'ArchiPro',
            url: host,
            potentialAction: {
                '@type': 'SearchAction',
                target: host + '/search?search={search_term_string}',
                'query-input': 'required name=search_term_string',
            },
        },
    ];
};
